import { PRIMARY, UTILITY1, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { safetyMargins, FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH, middle } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
  exception: makeThemeColor(UTILITY1),
  border: makeThemeColor(PRIMARY),
};

export const LOGO_HEIGHT = {
  [HD]: 64,
  [FULL_HD]: 72,
};

export const TITLE_WIDTH = {
  [HD]: 900,
  [FULL_HD]: 955,
};

export const EXCEPTION_HEIGHT = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const PASSWORD_OFFSET_TOP = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const EXCEPTION_OFFSET = 12;

export const FORGOT_CODE_BUTTON_OFFSET = 40;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  zIndex: 1,
  Background: {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
  },
  Input: {
    Button: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
    },
    Content: {
      w: SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize] * 2,
      h: SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2,
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      CustomerIcon: {
        h: LOGO_HEIGHT[screenSize],
      },
      Title: {
        text: {
          ...getFont(FONT.PARIS_3, screenSize),
          maxLines: 2,
          maxLinesSuffix: '...',
          wordWrapWidth: TITLE_WIDTH[screenSize],
          textAlign: 'center',
          textColor: colors.title[colorMode],
        },
      },
      PasswordBlock: {
        flexItem: { marginTop: PASSWORD_OFFSET_TOP[screenSize] },
      },
      ExceptionWrapper: {
        h: EXCEPTION_HEIGHT[screenSize],
        Exception: {
          alpha: 0,
          x: middle,
          y: middle,
          mount: 0.5,
          text: {
            ...getFont(FONT.OTTAWA_2, screenSize),
            textColor: colors.exception[colorMode],
            verticalAlign: 'middle',
          },
        },
      },
      Keyboard: {
        flexItem: { marginTop: EXCEPTION_OFFSET },
      },
      ForgotCodeButton: {
        flexItem: { marginTop: FORGOT_CODE_BUTTON_OFFSET },
      },
    },
  },
  ForgotCodeHint: {
    visible: false,
  },
});
